import {AppService} from "../typescript/app/app.service";
import {CityService} from "../typescript/city/city.service";
import {PageResponse} from "../typescript/util/page-response";
import {Neighborhood} from "./neighborhood";

class NeighborhoodService {

    static API_URL = "/api/bairros/v2";

    static findAll = (page?: number, size?: number, sort?: string, filter?: string): Promise<PageResponse<Neighborhood>> => {
        return AppService.getAuthorized(this.API_URL, {
            page: page,
            size: size,
            sort: sort,
            id: sort?.startsWith('id') ? filter : '',
            descricao: sort?.startsWith('descricao') ? filter : '',
            cidade: sort?.startsWith('cidade') ? filter : ''
        }).then((result) => {
            return result.data;
        }).catch(() => {
            return {
                content: [],
                totalElements: 0
            };
        })
    };

    static findOne(id: number) {
        return AppService.getAuthorized(this.API_URL + "/" + id).then((result) => {
            return result.data;
        }).catch(() => {
            return null;
        })
    }

    static save(item: Neighborhood) {
        if (item.id) {
            return AppService.postAuthorized(this.API_URL + "/" + item.id, item);
        } else {
            return AppService.postAuthorized(this.API_URL, item);
        }
    }

    static delete(id: number) {
        return AppService.deleteAuthorized(this.API_URL + "/" + id);
    }

    static createNeighborhood() {
        const neighborhood: Neighborhood = {
            descricao: '',
            cidade: CityService.createCity()
        }
        return neighborhood;
    }
}

export {NeighborhoodService};